import { Component, OnInit } from '@angular/core';
import { ProductStorageCapacityService } from '../../../services/product-storage-capacity.service';
import { ProductService } from '../../../../products/services/product.service';


@Component({
  selector: 'app-list-product-storage-capacities',
  templateUrl: './list-product-storage-capacities.component.html',
  styleUrls: ['./list-product-storage-capacities.component.css'],
  providers:[ProductStorageCapacityService,ProductService]
})
export class ListProductStorageCapacitiesComponent implements OnInit {

  productStorageCapacities:any = [];

  constructor(private productStorageCapacityService:ProductStorageCapacityService, private productService:ProductService) { }

  ngOnInit() {
    this.getProductStorageCapacities();
  }

  getProductStorageCapacities(){
    this.productStorageCapacityService.query({})
      .subscribe((productStorageCapacities) => {
        this.productStorageCapacities = productStorageCapacities;
        this.parseProducts();
      });
  }

  delete(productStorageCapacity){
    this.productService.query({telephone_company:productStorageCapacity.id})
    .subscribe((products) => {
      if (products.length > 0){
        alert("No se puede borrar debido ha que existen productos relacionados")
      }else{
        this.productStorageCapacityService.delete(productStorageCapacity.id)
        .subscribe((productStorageCapacity) => {
          this.getProductStorageCapacities()
        });
      }
    });
  }

  parseProducts(){
    this.productStorageCapacities.forEach(function (productStorageCapacity){
      productStorageCapacity.productTypes = "";
      if(productStorageCapacity.product_types.includes("1")){
        productStorageCapacity.productTypes += "Móviles y Tablets,";
      }
      if(productStorageCapacity.product_types.includes("2")){
        productStorageCapacity.productTypes += "Consolas,";
      }
      if(productStorageCapacity.product_types.includes("3")){
        productStorageCapacity.productTypes += "Artículos Varios,";
      }
      if(productStorageCapacity.product_types.includes("4")){
        productStorageCapacity.productTypes += "PC's-portátiles,";
      }
      productStorageCapacity.productTypes = productStorageCapacity.productTypes.substring(0,productStorageCapacity.productTypes.length - 1);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/product-storage-capacities/list-product-storage-capacities/list-product-storage-capacities.component.ts